import React, { useCallback } from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import Toggle from '@atlaskit/toggle/toggle';

type FooterProps = {
	isSynced: boolean;
	onSyncedChange?(isSynced: boolean): void;
	testId?: string;
};

const styles = cssMap({
	label: {
		display: 'block',
		flexGrow: 1,
	},
});

/**
 * __Footer__
 *
 * The appearance controls footer.
 */
const Footer = ({ isSynced, onSyncedChange, testId }: FooterProps): React.JSX.Element => {
	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			onSyncedChange?.(e.target.checked);
		},
		[onSyncedChange],
	);

	return (
		<Inline space="space.025" alignBlock="center">
			<Box xcss={styles.label}>
				<label htmlFor="apply-to-all-components">Apply to all components</label>
			</Box>
			<Toggle
				id="apply-to-all-components"
				isChecked={isSynced}
				onChange={handleChange}
				testId={testId ? `${testId}--sync` : undefined}
			/>
		</Inline>
	);
};

export default Footer;
